import React, { useEffect, useState } from "react";
import { Alert, Input, Button } from "reactstrap";
import StepCompleteActionButton from "./StepCompleteActionButton";

const EadFlow = ({
    preview,
    rawText,
    email,
    onSubmit,
    onRetake
}) => {
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    const [fields, setFields] = useState({
        aNumber: "",
        eadExpiration: ""
    });

    const updateField = (k, v) =>
        setFields(prev => ({ ...prev, [k]: v }));

    // -------------------------------------
    // EAD OCR PARSER
    // -------------------------------------
    const parseEAD = (raw) => {
        const lines = raw.split("\n").map(l => l.trim()).filter(Boolean);
        let aNum = "";
        let exp = "";

        for (const line of lines) {
            const hyphens = (line.match(/-/g) || []).length;
            if (hyphens === 2) aNum = line; // A typical A-number format
        }

        if (!aNum) {
            const m = raw.match(/(A[\d\-]{5,})/i);
            if (m) aNum = m[1].toUpperCase();
        }

        let idx = lines.findIndex(l => l.toLowerCase().includes("xpire"));
        if (idx !== -1) {
            const candidates = [
                lines[idx],
                lines[idx + 1],
                lines[idx + 2]
            ].filter(Boolean);

            const patterns = [
                /\b(\d{1,2}\/\d{1,2}\/\d{2,4})\b/,
                /\b(\d{1,2} [A-Za-z]{3} \d{4})\b/
            ];

            for (const c of candidates) {
                for (const p of patterns) {
                    const m = c.match(p);
                    if (m) exp = m[1];
                }
            }
        }

        // backup expiration finder
        if (!exp) {
            for (let i = 0; i < lines.length; i++) {
                if (lines[i].toLowerCase().includes("xpir")) {
                    const r = /\b(\d{1,2}\/\d{1,2}\/\d{2,4})\b/;
                    const m1 = lines[i].match(r);
                    const m2 = lines[i + 1]?.match(r);
                    if (m1) exp = m1[1];
                    else if (m2) exp = m2[1];
                }
            }
        }

        if (!exp) {
            for (let i = 0; i < lines.length; i++) {
                if (lines[i].toLowerCase().includes("xpr")) {
                    const r = /\b(\d{1,2}\/\d{1,2}\/\d{2,4})\b/;
                    const m1 = lines[i].match(r);
                    const m2 = lines[i + 1]?.match(r);
                    if (m1) exp = m1[1];
                    else if (m2) exp = m2[1];
                }
            }
        }

        setFields({
            aNumber: aNum,
            eadExpiration: exp
        });
    };

    useEffect(() => {
        if (rawText) parseEAD(rawText);
    }, [rawText]);

    // -------------------------------------
    // FINAL SUBMIT
    // -------------------------------------
    const submitFinal = async () => {
        setError("");
        setLoading(true);

        if (!fields.aNumber) {
            setError("A-number required");
            setLoading(false);
            return;
        }

        const payload = {
            type: "ead",
            data: {
                email,
                a_number: fields.aNumber,
                expiration_date: fields.eadExpiration
            }
        };

        try {
            const resp = await onSubmit(payload);
            if (!resp || resp.code !== 1) {
                setError(resp?.message || "Save failed");
                setLoading(false);
                return;
            }
        } catch (err) {
            setError("Unexpected error");
            setLoading(false);
        }
    };

    // -------------------------------------
    // UI
    // -------------------------------------
    return (
        <>
            {error && <Alert color="danger">{error}</Alert>}

            <h1 className="text-dark mb-3 fw-semibold">Verify EAD Card</h1>

            {preview && (
                <img
                    src={preview}
                    alt="ead"
                    style={{
                        width: "100%",
                        borderRadius: 8,
                        marginBottom: 20
                    }}
                />
            )}

            <label>A Number</label>
            <Input
                className="mb-3"
                value={fields.aNumber}
                onChange={(e) => updateField("aNumber", e.target.value.toUpperCase())}
            />

            <label>Expiration Date</label>
            <Input
                className="mb-3"
                value={fields.eadExpiration}
                onChange={(e) => updateField("eadExpiration", e.target.value)}
                placeholder="MM/DD/YYYY"
            />

            <StepCompleteActionButton
                label={loading ? "SAVING..." : "SUBMIT"}
                onClick={submitFinal}
                disabled={loading}
            />

            <Button className="w-100 mt-2" color="secondary" onClick={onRetake}>
                RETAKE PICTURE
            </Button>
        </>
    );
};

export default EadFlow;